
import { combineReducers } from 'redux';
import {project} from './project.reducer';
import {device} from './device.reducer';


/*
import medicationsReducers from './medicationsReducers';
import insurancesReducers from './insurancesReducers';
import providersReducers from './providersReducers';
import behaviorsReducers from './behaviorsReducers';
*/

const rootReducer = combineReducers({
    project,
    device,

    /*
    medications: medicationsReducers,
    insurances: insurancesReducers,
    providers: providersReducers,
    behaviors: behaviorsReducers
    */
});

export default rootReducer;